export enum SchemaDictionaryNames {
	'CVReview:1' = 'FORM1004',
	'CVReview1073:1' = 'FORM1073',
	'CVReview1075:1' = 'FORM1075',
	'CVReview2055:1' = 'FORM2055',
	'InspectionReport:3' = 'FNMA',
	'InspectionReport:3.3' = 'IMSimpleScan',
	'InspectionReport:3.4' = 'IMSimpleInspection',
	'InspectionReport:4' = 'IMSimpleInspection',
	'Inspectionless:1' = 'IMSimpleInspection',
	'Inspectionless:1.1' = 'IMSimpleInspection'
}

export enum FORMTYPE {
	FORM1004 = '1004',
	FORM1073 = '1073',
	FORM1075 = '1075',
	FORM2055 = '2055',
	FREDDIE = 'FREDDIE',
	FNMA = 'FNMA',
	IMSimpleInspection = 'IMSimpleInspection'
}
